// extracted by mini-css-extract-plugin
export default {"toggleButtonGroup":"ToggleButton_toggleButtonGroup__MMWaE","toggleBtn":"ToggleButton_toggleBtn__pNtc5","active":"ToggleButton_active__I+lnt"};